if (!customElements.get('menu-pills')) {
  class MenuPills extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-pills__list',
      };
      this.classes = {
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = this.dataset.items || 'auto';
      this.spaceBetween = parseInt(this.dataset.spaceBetween, 10) || 8;

      this.sliderInstance = false;

      if (!this.enableSlider || !this.sliderWrapper) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const sliderOptions = {
        slidesPerView: this.items,
        spaceBetween: this.spaceBetween,
        navigation: false,
        pagination: false,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      if (this.sliderWrapper) {
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      }
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    disconnectedCallback() {
      this.destroySlider();
    }
  }
  customElements.define('menu-pills', MenuPills);
}
